export default __webpack_public_path__ + "static/media/error.5b456c98.png";